import { render, staticRenderFns } from "./ChatChannelsList.vue?vue&type=template&id=be435b2e&scoped=true"
import script from "./ChatChannelsList.vue?vue&type=script&lang=js"
export * from "./ChatChannelsList.vue?vue&type=script&lang=js"
import style0 from "./ChatChannelsList.vue?vue&type=style&index=0&id=be435b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be435b2e",
  null
  
)

export default component.exports